import { reduxKey } from './constants';
function getState(state) {
    return state[reduxKey] || {};
}
export function getTooltipState(state, username) {
    return username && getState(state)[username.toLowerCase()] || {};
}
export function getIsInitialized(state, username) {
    return Boolean(username) && state[reduxKey] !== undefined && state[reduxKey][username.toLowerCase()] !== undefined;
}
export function getIsLoading(state, username) {
    return getTooltipState(state, username).isLoading;
}

//# sourceMappingURL=selectors.js.map